module.exports = __webpack_public_path__ + "img/ThorstenRafalzik_140x140_rund.24a81f43.jpg";